import {ReportNavigatorService} from '../services/report-navigator.service';
import { Component, OnInit, Input } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';
import { AssessmentResult } from 'app/shared/models/assessment-result';
import { Question } from 'app/shared/models/question';
import { Scale } from 'app/shared/models/scale';
import { QuestionSet } from 'app/shared/models/question-set';
import { PclGraderService } from 'app/reports/services/pcl-grader.service';

@Component({
  selector: 'app-pcl-summary',
  templateUrl: './pcl-summary.component.html'
})
export class PclSummaryComponent implements OnInit {

  @Input() summaryScaleResult:ScaleResult;
  @Input() assessmentResult:AssessmentResult;
  private _criteria:{name:string, hasPTSD:boolean, scaleResult:ScaleResult}[];
  
  constructor(private navigator:ReportNavigatorService, private pclGrader:PclGraderService) { 
    this._criteria = [];
  }

  ngOnInit() {
    if (this.assessmentResult) {
      this._criteria = this.pclGrader.getPCLCriteriaFromAssessmentResult(this.assessmentResult);
    }
  }

  get Criteria() : {name:string, hasPTSD:boolean, scaleResult:ScaleResult}[] {
    return this._criteria;
  }

  public goToScaleResult(scaleResult:ScaleResult) {
    if (this.navigator.hasNavigationItem(scaleResult.scale.id)) {
      this.navigator.navigate(scaleResult.scale.id);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/pcl-summary/pcl-summary.component.ts